import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SeoHead
        title="Page not found | AKAS"
        description="The page you requested could not be found on AKAS."
        path="/404"
        noIndex
      />
      <div className="flex items-center justify-center bg-gray-50 w-full min-h-[50vh] py-20 px-4">
        <div className="text-center lg:max-w-lg">
          <p className="text-9xl font-bold text-black opacity-10">404</p>
          <h1 className="text-2xl font-semibold mb-2">This page isn&apos;t available</h1>
          <p className="text-gray-500 mb-6">
            The link may be broken, or the page may have been removed.
          </p>
          <Link
            to="/"
            className="inline-block rounded-md px-6 py-3 text-white"
            style={{ backgroundColor: '#1766FF' }}
          >
            Back to home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
